import { useEffect, useMemo, useState } from 'react';

import { twMerge } from 'tailwind-merge';

import { SelectModalProps } from '../../types';
import { SelectModalWrapper } from '../select-modal';

export const SelectOptions = <T,>({
  options = [],
  modalProps = {},
  ...rest
}: SelectModalProps<T>) => {
  const [search, setSearch] = useState('');

  const searchedOptions = useMemo(() => {
    if (options.length <= 20) return options;
    return options.filter((option) =>
      option.label.toLowerCase().includes(search.toLowerCase()),
    );
  }, [options, search]);

  useEffect(() => {
    return () => {
      setSearch('');
    };
  }, []);

  return (
    <SelectModalWrapper
      {...rest}
      modalProps={{
        ...modalProps,
        className: twMerge('px-1 py-4', modalProps.className),
      }}
      options={searchedOptions}
      searchValue={search}
      onSearchChange={options?.length > 20 ? setSearch : undefined}
    />
  );
};
